import React, { useState } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { updatePortal } from '../../services/portal';

const AddPortals = (props) => {
    const [isLoading, setLoading] = useState(false);

    let validationShape = {
        name: Yup.string().required().label('Name'),
    };

    const { handleChange, values, handleSubmit, touched, errors } = useFormik({
        initialValues: props.fillData,
        enableReinitialize: true,
        validationSchema: Yup.object(validationShape),
        onSubmit: (values) => {
            if (props.getId !== 0) {
                updatePortalData(props.getId, values);
            }
        }
    });

    const updatePortalData = (id: number, values: any) => {
        setLoading(true);
        updatePortal(id, {
            "name": values.name
        }).then(function (res) {
            const resp = res.data;
            setLoading(false);
            if (resp.Acknowledge == 1) {
                toast.success('Record updated Successfully!');
                props.setShow(false);
                props.loadList();
            } else if (resp.FullMessage != "") {
                setLoading(false);
                toast.error(resp.FullMessage);
            }
        }).catch(err => {
            setLoading(false);
            toast.error('Internal Server Error!');
        });
    };

    return (
        <>
            <Modal show={props.show} onHide={props.handleClose} size="lg">
                {(props.isPopLoading || isLoading) && <div className="overlay">
                    <i className="fas fa-2x fa-sync fa-spin"></i>
                </div>}
                <Modal.Header closeButton>
                    <Modal.Title>{props.getId !== 0 ? 'Edit' : 'Add'} Portal</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Row>
                            <Form.Group className='col-md-6' controlId="price">
                                <Form.Label>Name</Form.Label>
                                <Form.Control
                                    name="name"
                                    type="text"
                                    placeholder="Enter Name"
                                    value={values.name}
                                    onChange={handleChange}
                                    isValid={touched.name && !errors.name}
                                    isInvalid={touched.name && !!errors.name}
                                />
                                {touched.name && errors.name ? (
                                    <Form.Control.Feedback type="invalid">
                                        {errors.name}
                                    </Form.Control.Feedback>
                                ) : ''}
                            </Form.Group>

                        </Form.Row>

                        <Button variant="primary" type="submit">
                            {props.getId !== 0 ? 'Update' : 'Add'} Portal
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal >
        </>
    );
};

export default AddPortals;
